<app-processing [visible]="!pageVars.isReady"></app-processing>

<div *ngIf="userSetttingsJson && userSetttingsJson['Default Site']" class="user-settings">
  <div>
    <span class="setting-key">Default Site: </span>
    <span class="setting-value">{{ userSetttingsJson['Default Site'] }}</span>
    &nbsp;
    <p-button icon="pi pi-pencil" text="true" [style]="{ height: '100%' }" (click)="onEditUserSettings()" data-testid="editUserSetting" />
  </div>
  <div class="flex align-items-center my-2">
    <p-toggleswitch [(ngModel)]="useCommonName" (onChange)="onToggleChange()" data-testid="useCommonName" inputId="useCommonName"> </p-toggleswitch>
    <label for="useCommonName" class="ml-2">Use Common Name</label>
  </div>

  <div class="flex align-items-center my-2">
    <p-toggleswitch [(ngModel)]="useSiteCode" (onChange)="onToggleChange()" data-testid="useSiteCode" inputId="useSiteCode"> </p-toggleswitch>
    <label for="useSiteCode" class="ml-2">Use Site Code</label>
  </div>
</div>

<p-dialog
  header="{{ dialogHeader }}"
  [(visible)]="pageVars.isEditing"
  [modal]="true"
  [closable]="false"
  (onHide)="pageVars.isEditting = false"
  appendTo="body"
  [style]="{ width: '400px' }"
  [contentStyle]="{ overflow: 'visible' }">
  <div class="mb-2"></div>
  <p-floatlabel variant="on">
    <p-select
      [(ngModel)]="selectedDefaultSite"
      [options]="sites"
      data-testid="defaultSite"
      optionLabel="label"
      optionValue="value"
      [style]="{ width: '100%' }"
      class="w-full"
      [overlayOptions]="{ appendTo: 'body', autoZIndex: true, baseZIndex: 2000, style: { maxHeight: '200px' } }"></p-select>
    <label for="on_label">Default Site</label>
  </p-floatlabel>
  <br />

  <div class="flex justify-content-between gap-2">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancel()" data-testid="defaultSiteCancel" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="onSaveUserSettings()"
      [disabled]="selectedDefaultSite === ''"
      data-testid="defaultSiteSave" />
  </div>
</p-dialog>
